import { ListItemText as MuiListItemText } from '@mui/material';
import { listItemTextClasses, ListItemTextProps } from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';

import { tokens } from '../../theme/styles/themeMui';

export type { ListItemTextProps };

export const ListItemText = styled(MuiListItemText)<ListItemTextProps>(() => ({
  [`&.${listItemTextClasses.root}`]: {
    ...tokens.typography.bodyMRegular,
    margin: 0,
  },
}));
